import type { CollaborationGraphContainer } from '@townsquare/collab-graph-provider/types';
import { createResource } from '@townsquare/router/resources/createResource';
import type { RouteResource } from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import { fetchWhereYouWorkContainers } from '../hooks/fetch-where-you-work-containers';

export const frequentContainersResource: RouteResource<CollaborationGraphContainer[]> =
	createResource<CollaborationGraphContainer[]>({
		type: 'CONTAINERS',
		getKey: (_, resourceContext) => {
			if (!fg('townsquare_where_you_work_preload')) {
				return 'CONTAINERS-FG-OFF';
			}

			const { orgId } = resourceContext as HomeResourceContext;

			return `CONTAINERS-${orgId}`;
		},
		getData: async (_, resourceContext) => {
			if (!fg('townsquare_where_you_work_preload')) {
				return [];
			}

			const {
				user: { accountId },
				collabContext,
				orgId,
			} = resourceContext as HomeResourceContext;

			const unitCloudIds = collabContext?.collabContextScoping?.collabContextCloudIds;

			if (!orgId || !accountId || !unitCloudIds) {
				return [];
			}

			return fetchWhereYouWorkContainers({ cloudIdsToFilterFor: unitCloudIds, orgId, accountId });
		},
	});
